import { Injectable } from '@angular/core';

import { Storage } from '@ionic/storage-angular';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  private cache = [];

  private _storage: Storage | null = null;

  constructor(private storage: Storage) {
  }

  async init(): Promise<void> {
    if (this._storage == null) {
      this._storage = await this.storage.create();
    }
  }

  async setEntry(key: string, value: any): Promise<any> {
    await this.init();
    this.cache[key] = value;
    return this._storage.set(key, value);
  }

  async getEntry(key: string): Promise<any> {
    await this.init();
    if (!(key in this.cache)) {
      this.cache[key] = await this._storage.get(key);
    }
    return this.cache[key];
  }

  async removeEntry(key: string): Promise<any> {
    await this.init();
    if (key in this.cache) {
      delete this.cache[key];
    }
    return this._storage.remove(key);
  }

}
